import { initTracker } from './tracker';
import { ANALYTICS_ENABLED, ANALYTICS_ADAPTERS } from './config';

export { track } from './tracker';
export { buildBasePayload, detectTemplate } from './buildBasePayload';
export { setAnalyticsContext, getAnalyticsContext } from './currentContext';
export { initBehaviour } from './behaviour';
export {
  initVisitOutcome,
  markVisitAction,
  markRequisiteCopied,
} from './visitOutcome';
export type { AnalyticsEvent, AnalyticsBasePayload, AnalyticsEventName } from './events';

export const initAnalytics = () => {
  initTracker({ enabled: ANALYTICS_ENABLED, adapters: ANALYTICS_ADAPTERS });
};
